namespace $ { export class $my_hack extends $piterjs_app {

	/**
	 *  ```
	 *  plugins /
	 *  	^
	 *  	<= Enter_speech
	 *  	<= Exit_speech
	 *  	<= Go_speech
	 *  	<= Backward
	 *  	<= Forward
	 *  ```
	 **/
	plugins() {
		return [...super.plugins() , this.Enter_speech() , this.Exit_speech() , this.Go_speech() , this.Backward() , this.Forward()] as readonly any[]
	}

	/**
	 *  ```
	 *  Enter_speech $mol_speech
	 *  	event_catch?val <=> enter?val
	 *  	suffix \
	 *  	patterns / \выбрать
	 *  ```
	 **/
	@ $mol_mem
	Enter_speech() {
		return (( obj )=>{
			obj.event_catch = ( val? : any ) => this.enter( val )
			obj.suffix = () => ""
			obj.patterns = () => ["выбрать"] as readonly any[]
			return obj
		})( new this.$.$mol_speech(  ) )
	}

	/**
	 *  ```
	 *  enter?val null
	 *  ```
	 **/
	@ $mol_mem
	enter( val? : any , force? : $mol_mem_force ) {
		return ( val !== void 0 ) ? val : null as any
	}

	/**
	 *  ```
	 *  Exit_speech $mol_speech
	 *  	event_catch?val <=> exit?val
	 *  	suffix \
	 *  	patterns / \убрать
	 *  ```
	 **/
	@ $mol_mem
	Exit_speech() {
		return (( obj )=>{
			obj.event_catch = ( val? : any ) => this.exit( val )
			obj.suffix = () => ""
			obj.patterns = () => ["убрать"] as readonly any[]
			return obj
		})( new this.$.$mol_speech(  ) )
	}

	/**
	 *  ```
	 *  exit?val null
	 *  ```
	 **/
	@ $mol_mem
	exit( val? : any , force? : $mol_mem_force ) {
		return ( val !== void 0 ) ? val : null as any
	}

	/**
	 *  ```
	 *  Go_speech $mol_speech
	 *  	event_catch?val <=> go?val
	 *  	suffix \
	 *  	patterns / \открыть (\S{2,})
	 *  ```
	 **/
	@ $mol_mem
	Go_speech() {
		return (( obj )=>{
			obj.event_catch = ( val? : any ) => this.go( val )
			obj.suffix = () => ""
			obj.patterns = () => ["открыть (\\S{2,})"] as readonly any[]
			return obj
		})( new this.$.$mol_speech(  ) )
	}

	/**
	 *  ```
	 *  go?val null
	 *  ```
	 **/
	@ $mol_mem
	go( val? : any , force? : $mol_mem_force ) {
		return ( val !== void 0 ) ? val : null as any
	}

	/**
	 *  ```
	 *  Backward $mol_speech
	 *  	event_catch?val <=> backward?val
	 *  	suffix \
	 *  	patterns / \предыдущий
	 *  ```
	 **/
	@ $mol_mem
	Backward() {
		return (( obj )=>{
			obj.event_catch = ( val? : any ) => this.backward( val )
			obj.suffix = () => ""
			obj.patterns = () => ["предыдущий"] as readonly any[]
			return obj
		})( new this.$.$mol_speech(  ) )
	}

	/**
	 *  ```
	 *  backward?val null
	 *  ```
	 **/
	@ $mol_mem
	backward( val? : any , force? : $mol_mem_force ) {
		return ( val !== void 0 ) ? val : null as any
	}

	/**
	 *  ```
	 *  Forward $mol_speech
	 *  	event_catch?val <=> forward?val
	 *  	suffix \
	 *  	patterns / \следующий
	 *  ```
	 **/
	@ $mol_mem
	Forward() {
		return (( obj )=>{
			obj.event_catch = ( val? : any ) => this.forward( val )
			obj.suffix = () => ""
			obj.patterns = () => ["следующий"] as readonly any[]
			return obj
		})( new this.$.$mol_speech(  ) )
	}

	/**
	 *  ```
	 *  forward?val null
	 *  ```
	 **/
	@ $mol_mem
	forward( val? : any , force? : $mol_mem_force ) {
		return ( val !== void 0 ) ? val : null as any
	}

	/**
	 *  ```
	 *  sub /
	 *  	<= Control
	 *  	^
	 *  ```
	 **/
	sub() {
		return [this.Control() , ...super.sub()] as readonly any[]
	}

	/**
	 *  ```
	 *  Control $mol_view sub /
	 *  	<= Mirror
	 *  	<= Speech_panel
	 *  ```
	 **/
	@ $mol_mem
	Control() {
		return (( obj )=>{
			obj.sub = () => [this.Mirror() , this.Speech_panel()] as readonly any[]
			return obj
		})( new this.$.$mol_view(  ) )
	}

	/**
	 *  ```
	 *  Mirror $mol_view sub /
	 *  	<= Camera
	 *  	<= Skeleton
	 *  ```
	 **/
	@ $mol_mem
	Mirror() {
		return (( obj )=>{
			obj.sub = () => [this.Camera() , this.Skeleton()] as readonly any[]
			return obj
		})( new this.$.$mol_view(  ) )
	}

	/**
	 *  ```
	 *  Camera $mol_view
	 *  	dom_name \video
	 *  	field * srcObject <= camera
	 *  	event * loadedmetadata?event <=> camera_ready?event
	 *  ```
	 **/
	@ $mol_mem
	Camera() {
		return (( obj )=>{
			obj.dom_name = () => "video"
			obj.field = () => ({
			"srcObject" :  this.camera() ,
		})
			obj.event = () => ({
			"loadedmetadata" :  ( event? : any )=>  this.camera_ready( event ) ,
		})
			return obj
		})( new this.$.$mol_view(  ) )
	}

	/**
	 *  ```
	 *  camera null
	 *  ```
	 **/
	camera() {
		return null as any
	}

	/**
	 *  ```
	 *  camera_ready?event null
	 *  ```
	 **/
	@ $mol_mem
	camera_ready( event? : any , force? : $mol_mem_force ) {
		return ( event !== void 0 ) ? event : null as any
	}

	/**
	 *  ```
	 *  Skeleton $mol_view dom_name \canvas
	 *  ```
	 **/
	@ $mol_mem
	Skeleton() {
		return (( obj )=>{
			obj.dom_name = () => "canvas"
			return obj
		})( new this.$.$mol_view(  ) )
	}

	/**
	 *  ```
	 *  Speech_panel $mol_list rows /
	 *  	<= Speech_hint
	 *  	<= Speech_bar
	 *  ```
	 **/
	@ $mol_mem
	Speech_panel() {
		return (( obj )=>{
			obj.rows = () => [this.Speech_hint() , this.Speech_bar()] as readonly any[]
			return obj
		})( new this.$.$mol_list(  ) )
	}

	/**
	 *  ```
	 *  Speech_hint $mol_row sub /
	 *  	<= Backward_hint
	 *  	<= Forward_hint
	 *  	<= Enter_hint
	 *  	<= Exit_hint
	 *  	<= Go_hint
	 *  ```
	 **/
	@ $mol_mem
	Speech_hint() {
		return (( obj )=>{
			obj.sub = () => [this.Backward_hint() , this.Forward_hint() , this.Enter_hint() , this.Exit_hint() , this.Go_hint()] as readonly any[]
			return obj
		})( new this.$.$mol_row(  ) )
	}

	/**
	 *  ```
	 *  Backward_hint $my_hack_command
	 *  	Icon <= Backward_icon
	 *  	hint \предыдущий
	 *  ```
	 **/
	@ $mol_mem
	Backward_hint() {
		return (( obj )=>{
			obj.Icon = () => this.Backward_icon()
			obj.hint = () => "предыдущий"
			return obj
		})( new this.$.$my_hack_command(  ) )
	}

	/**
	 *  ```
	 *  Backward_icon $mol_icon_hand_left
	 *  ```
	 **/
	@ $mol_mem
	Backward_icon() {
		return (( obj )=>{
			return obj
		})( new this.$.$mol_icon_hand_left(  ) )
	}

	/**
	 *  ```
	 *  Forward_hint $my_hack_command
	 *  	Icon <= Forward_icon
	 *  	hint \следующий
	 *  ```
	 **/
	@ $mol_mem
	Forward_hint() {
		return (( obj )=>{
			obj.Icon = () => this.Forward_icon()
			obj.hint = () => "следующий"
			return obj
		})( new this.$.$my_hack_command(  ) )
	}

	/**
	 *  ```
	 *  Forward_icon $mol_icon_hand_right
	 *  ```
	 **/
	@ $mol_mem
	Forward_icon() {
		return (( obj )=>{
			return obj
		})( new this.$.$mol_icon_hand_right(  ) )
	}

	/**
	 *  ```
	 *  Enter_hint $my_hack_command
	 *  	Icon <= Enter_icon
	 *  	hint \выбрать
	 *  ```
	 **/
	@ $mol_mem
	Enter_hint() {
		return (( obj )=>{
			obj.Icon = () => this.Enter_icon()
			obj.hint = () => "выбрать"
			return obj
		})( new this.$.$my_hack_command(  ) )
	}

	/**
	 *  ```
	 *  Enter_icon $mol_icon_thumb_up
	 *  ```
	 **/
	@ $mol_mem
	Enter_icon() {
		return (( obj )=>{
			return obj
		})( new this.$.$mol_icon_thumb_up(  ) )
	}

	/**
	 *  ```
	 *  Exit_hint $my_hack_command
	 *  	Icon <= Exit_icon
	 *  	hint \убрать
	 *  ```
	 **/
	@ $mol_mem
	Exit_hint() {
		return (( obj )=>{
			obj.Icon = () => this.Exit_icon()
			obj.hint = () => "убрать"
			return obj
		})( new this.$.$my_hack_command(  ) )
	}

	/**
	 *  ```
	 *  Exit_icon $mol_icon_hand_peace
	 *  ```
	 **/
	@ $mol_mem
	Exit_icon() {
		return (( obj )=>{
			return obj
		})( new this.$.$mol_icon_hand_peace(  ) )
	}

	/**
	 *  ```
	 *  Go_hint $my_hack_command hint \открыть [слово]
	 *  ```
	 **/
	@ $mol_mem
	Go_hint() {
		return (( obj )=>{
			obj.hint = () => "открыть [слово]"
			return obj
		})( new this.$.$my_hack_command(  ) )
	}

	/**
	 *  ```
	 *  Speech_bar $mol_view sub /
	 *  	<= Speech_toggle
	 *  	<= Speech_text
	 *  ```
	 **/
	@ $mol_mem
	Speech_bar() {
		return (( obj )=>{
			obj.sub = () => [this.Speech_toggle() , this.Speech_text()] as readonly any[]
			return obj
		})( new this.$.$mol_view(  ) )
	}

	/**
	 *  ```
	 *  Speech_toggle $mol_check_icon
	 *  	Icon <= Speech_toggle_icon
	 *  	checked?val <=> speech_enabled?val
	 *  	hint <= speech_toggle_hint
	 *  ```
	 **/
	@ $mol_mem
	Speech_toggle() {
		return (( obj )=>{
			obj.Icon = () => this.Speech_toggle_icon()
			obj.checked = ( val? : any ) => this.speech_enabled( val )
			obj.hint = () => this.speech_toggle_hint()
			return obj
		})( new this.$.$mol_check_icon(  ) )
	}

	/**
	 *  ```
	 *  Speech_toggle_icon $mol_icon_microphone
	 *  ```
	 **/
	@ $mol_mem
	Speech_toggle_icon() {
		return (( obj )=>{
			return obj
		})( new this.$.$mol_icon_microphone(  ) )
	}

	/**
	 *  ```
	 *  speech_enabled?val false
	 *  ```
	 **/
	@ $mol_mem
	speech_enabled( val? : any , force? : $mol_mem_force ) {
		return ( val !== void 0 ) ? val : false
	}

	/**
	 *  ```
	 *  speech_toggle_hint @ \Speech contol
	 *  ```
	 **/
	speech_toggle_hint() {
		return this.$.$mol_locale.text( "$my_hack_speech_toggle_hint" )
	}

	/**
	 *  ```
	 *  Speech_text $mol_view sub / <= speech_text
	 *  ```
	 **/
	@ $mol_mem
	Speech_text() {
		return (( obj )=>{
			obj.sub = () => [this.speech_text()] as readonly any[]
			return obj
		})( new this.$.$mol_view(  ) )
	}

	/**
	 *  ```
	 *  speech_text \
	 *  ```
	 **/
	speech_text() {
		return ""
	}

} }
namespace $ { export class $my_hack_command extends $mol_list {

	/**
	 *  ```
	 *  rows /
	 *  	<= Icon
	 *  	<= Hint
	 *  ```
	 **/
	rows() {
		return [this.Icon() , this.Hint()] as readonly any[]
	}

	/**
	 *  ```
	 *  Icon $mol_icon
	 *  ```
	 **/
	@ $mol_mem
	Icon() {
		return (( obj )=>{
			return obj
		})( new this.$.$mol_icon(  ) )
	}

	/**
	 *  ```
	 *  Hint $mol_view sub / <= hint
	 *  ```
	 **/
	@ $mol_mem
	Hint() {
		return (( obj )=>{
			obj.sub = () => [this.hint()] as readonly any[]
			return obj
		})( new this.$.$mol_view(  ) )
	}

	/**
	 *  ```
	 *  hint \
	 *  ```
	 **/
	hint() {
		return ""
	}

} }
